function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function acceptCookies() {
    setCookie('cookie_consent', 'true', 30);
    $('#cookie-bar').hide();
}

function rejectCookies() {
    setCookie('cookie_consent', 'false', 30);
    $('#cookie-bar').hide();
}

function cookiePrompt() {
    $('#cookie-bar').show();
}

function refreshProcess() {
    if ($('#process').hasClass('mobile')) {

        var width = $('#process .controls').width();

        var factor = width / 80 - 1;
        var count = 0;
        var bullets = [];
        $('#process_slider').find('li').each(function (index, item) {
            var id = '0' + (index + 1);
            var title = $(item).find('.em-t').text();
            var subtitle = $(item).find('h3').find('.em-st').text();
            var bullet = '<div class="mw-bullet" data-slide="' + index + '"><div class="ball"></div><div class="content"><div class="legend">' + id + '</div><h3>' + title + '</h3><div class="text">' + subtitle + '</div></div></div>';
            bullets.push(bullet);
            count++;
        });

        var markings = '<div class="long"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';
        markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';
        markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';
        markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

        for (var i = 0; i < count; i++) {

            markings = markings + '<div class="long" style="margin-left: ' + factor + 'px">' + bullets[i] + '</div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

            markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

            markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

            markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

        }
        markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="long" style="margin-left: ' + factor + 'px"></div>';
        $('#markings').html(markings);
        $('#markings').css('width', ((factor + 1) * 361) + 'px');
        $('#process .controls .scroller .bar').css('width', ((factor + 1) * 40 + 4) + 'px');
        $('#process .controls .scroller').css('width', ((factor + 1) * 40 + 4) + 'px');
        $('#process .controls .scroller').css('margin-left', '-' + ((factor + 1) * 20 + 2) + 'px');
        $('#process .controls .scroller').css('left', '50%');
        $('#markings').css('left', '-' + ((factor + 1) * 40) * ($(document).data('process_slide') - 1) + 'px');
        var active = $('#markings').find('.mw-bullet[data-slide="' + ($(document).data('process_slide') - 1) + '"]');
        $('.mw-bullet').removeClass('active');
        $(active).addClass('active');
    } else {
        var width = $('#markings').width();
        console.log(width);
        var count = 0;
        var bullets = [];
        $('#process_slider').find('li').each(function (index, item) {
            var id = '0' + (index + 1);
            var title = $(item).find('.em-t').text();
            var subtitle = $(item).find('h3').find('.em-st').text();
            var bullet = '<div class="mw-bullet" data-slide="' + index + '"><div class="ball"></div><div class="content"><div class="legend">' + id + '</div><h3>' + title + '</h3><div class="text">' + subtitle + '</div></div></div>';
            bullets.push(bullet);
            count++;
        });
        var needed = count * 3 + 2;
        var cms = Math.floor(width / 20);
        var factor = (2 * cms / needed) - 1;

        var markings = '<div class="long"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

        for (var i = 0; i < count; i++) {

            markings = markings + '<div class="long" style="margin-left: ' + factor + 'px">' + bullets[i] + '</div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

            markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

            markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div>';

        }
        markings = markings + '<div class="long" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="medium" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="short" style="margin-left: ' + factor + 'px"></div><div class="long" style="margin-left: ' + factor + 'px"></div>';
        $('#markings').html(markings);
        $('#process .controls .scroller .bar').css('width', ((factor + 1) * 20 + 4) + 'px');
        $('#process .controls .scroller').css('width', ((factor + 1) * 20 + 4) + 'px');
        $('#process .controls .scroller').css('margin-left', '-' + ((factor + 1) * 10 + 2) + 'px');
        $('#markings').find('.mw-bullet[data-slide="' + ($(document).data('process_slide') - 1) + '"]').trigger('click');

    }
}
function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
var process_slider;
$(document).ready(function () {

    var toggleAffix = function (affixElement, scrollElement, wrapper) {

        var height = affixElement.outerHeight(),
            top = wrapper.offset().top;

        if (scrollElement.scrollTop() >= top) {
            wrapper.height(height);
            affixElement.addClass("affix");
        } else {
            affixElement.removeClass("affix");
            wrapper.height('auto');
        }

    };
    $("nav ul li a[href^='#']").on('click', function (e) {

        // prevent default anchor click behavior
        e.preventDefault();

        // store hash
        var hash = this.hash;

        // animate
        $('html, body').animate({
            scrollTop: $(hash).offset().top
        }, 300, function () {

            // when done, add hash to url
            // (default click behaviour)
            window.location.hash = hash;
        });

    });
    if (getCookie('cookie_consent') == 'true') {
        /*
        if ($('#cookiescheck')) {
            $('#cookiescheck').prop('checked',true);
        }
		(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
			(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
			m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
		})(window,document,'script','//www.google-analytics.com/analytics.js','__gaTracker');

		__gaTracker('create', '', 'auto');
		__gaTracker('set', 'forceSSL', true);
		__gaTracker('require', 'displayfeatures');
		__gaTracker('require', 'linkid', 'linkid.js');
        __gaTracker('send','pageview');
        */
        setCookie('cookie_consent', 'true', 30);

    } else {
        cookiePrompt();
    }

    $('[data-toggle="affix"]').each(function () {
        var ele = $(this),
            wrapper = $('<div></div>');

        ele.before(wrapper);
        $(window).on('scroll resize', function () {
            toggleAffix(ele, $(this), wrapper);
        });

        // init
        toggleAffix(ele, $(window), wrapper);
    });
    var slider = $('#history_slider').lightSlider({
        item: 3,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 0,
        addClass: 'active',
        mode: "slide",
        useCSS: true,
        slideEndAnimation: false,
        freeMove: false,
        centerSlide: true,
        cssEasing: 'ease',
        enableTouch: true,
        enableDrag:false,
        loop: false,
        pager: false,
        easing: 'linear',
        onAfterSlide: function (el) {
            var slide = el.getCurrentSlideCount();
            if (slide == 1) {
                el.goToSlide(1);
            }
            if (slide == 5) {
                el.goToSlide(3);
            }
            if (slide == 3) {
                $('#history .buttons .prev').show();
                $('#history .buttons .next').show();
            }
            if (slide == 2) {
                $('#history .buttons .prev').hide();
                $('#history .buttons .next').show();
            }
            if (slide == 4) {
                $('#history .buttons .prev').show();
                $('#history .buttons .next').hide();
            }
        },
        responsive: [{
            breakpoint: 768,
            settings: {
                item: 1,
                slideMove: 1,
                slideMargin: 0,
            }
        }]
    });
    console.log(slider.getCurrentSlideCount());
    $('#history .buttons .prev').hide();
    $('#history .buttons .next').show();
    $(document).data('process_slide', 1);
    process_slider = $('#process_slider').lightSlider({
        item: 1,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 0,
        addClass: 'active',
        mode: "slide",
        useCSS: true,
        slideEndAnimation: false,
        freeMove: false,
        centerSlide: true,
        cssEasing: 'ease',
        enableTouch: true,
        enableDrag:false,
        loop: false,
        pager: false,
        easing: 'linear',
        onAfterSlide: function (el) {
            $(document).data('process_slide', el.getCurrentSlideCount());

            var active = $('#markings').find('.mw-bullet[data-slide="' + ($(document).data('process_slide') - 1) + '"]');
            $('.mw-bullet').removeClass('active');
            $(active).addClass('active');
            if ($('#process').hasClass('mobile')) {
                var width = $('#process .controls').width();
                var factor = width / 80 - 1;

                $('#process .controls .scroller').css('left', '50%');
                $('#markings').css('left', '-' + ((factor + 1) * 40) * ($(document).data('process_slide') - 1) + 'px');
            } else {
                $('.scroller').css('left', $('#markings').find('.mw-bullet[data-slide="' + ($(document).data('process_slide') - 1) + '"]').css('left'));
            }
        }
    });
    if ($(window).width() < 768) {
        if (!$('#process').hasClass('mobile')) {
            $('#process').addClass('mobile');
        }
    } else {
        if ($('#process').hasClass('mobile')) {
            $('#process').removeClass('mobile');
        }
    }
    refreshProcess();
    $(window).resize(function () {
        if ($(window).width() < 768) {
            if (!$('#process').hasClass('mobile')) {
                $('#process').addClass('mobile');
            }
        } else {
            if ($('#process').hasClass('mobile')) {
                $('#process').removeClass('mobile');
            }
        }
        process_slider.refresh();

        refreshProcess();
    });
    var certs_slider = $('#certs_slider').lightSlider({
        item: 3,
        autoWidth: false,
        slideMove: 1, // slidemove will be 1 if loop is true
        slideMargin: 0,
        slideEndAnimation: false,
        freeMove: false,
        addClass: 'active',
        mode: "slide",
        useCSS: true,
        centerSlide: true,
        cssEasing: 'ease',
        loop: false,
        pager: false,
        enableTouch: true,
        enableDrag:false,
        easing: 'linear',
        responsive: [{
            breakpoint: 768,
            settings: {
                item: 1,
                slideMove: 1,
                slideMargin: 0,
            }
        }]
    });
    slider.goToSlide(1);
    $('#history .buttons .prev').click(function () {
        if (slider.getCurrentSlideCount() != 2) {
            slider.goToPrevSlide();
        }
    });
    $('#history .buttons .next').click(function () {
        if (slider.getCurrentSlideCount() != 4) {
            slider.goToNextSlide();
        }
    })
    $('.mw-bullet[data-slide="0"]').addClass('active');
    $('.scroller').css('left', $('.mw-bullet[data-slide="0"]').css('left'));
    $('.markings').on('click', '.mw-bullet', function () {
        if (!$('#process').hasClass('mobile')) {
            process_slider.goToSlide($(this).data('slide'));
        }
    })
});

function sendContact() {
    var valid = true;
    $('#fullname').parent().find('.error').hide();
    $('#email').parent().find('.error').hide();
    $('#message').parent().find('.error').hide();
    $('.error-terms').hide();
    if ($('#fullname').val().trim() == '') {
        valid = false;
        $('#fullname').parent().find('.error').show();
        $('#fnerr').html('THIS FIELD IS REQUIRED');
    }
    if ($('#email').val().trim() == '') {
        valid = false;
        $('#email').parent().find('.error').show();
        $('#emerr').html('THIS FIELD IS REQUIRED');
    }
    if ($('#email').val().trim() != '' && !validateEmail($('#email').val()))  {
        valid = false;
        $('#email').parent().find('.error').show();
        $('#emerr').html('YOU MUST ENTER A VALID EMAIL ADDRESS');
    }
    if ($('#message').val().trim() == '') {
        valid = false;
        $('#message').parent().find('.error').show();
        $('#msgerr').html('THIS FIELD IS REQUIRED');
    }
    if (!($('#terms').is(':checked'))) {
        valid = false;
        $('.error-terms').show();
    }
    if (valid) {
        grecaptcha.execute('6LeoE44UAAAAAOxO3XMOKFGW0VrOejNJJq2lAirt', {
                action: 'contactForm'
            })
            .then(function (token) {
                console.log(token);
                $('#token').val(token);
                $.post('contact.php', $('#contactForm').serialize(), function (data) {
                    console.log(data);
                    if (data.success) {
                        location.href = "thankyou.html";
                    }
                }, 'json')
            });
    }
}